import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { TbUserScan } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { HotelDepartureStatusItem, hotelDepartureStatuses } from "@/constants/hotelDepartureStatuses";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import {
    IHotelPlanningDepartureResponseItem,
    PatientHotelDepartureStatuses,
} from "@/schemas/hotelPlanningDepartureSchema";

export function RenderHotelDepartureStatusCellTooltip({ status }: { status: HotelDepartureStatusItem }) {
    return (
        <NoMaxWidthTooltip
            arrow
            sx={{
                [`& .${tooltipClasses.tooltip}`]: {
                    backgroundColor: "white",
                    border: "none",
                    padding: "0px !important",
                    fontSize: 12,
                    maxWidth: "200px !important",
                },
            }}
            title={<HotelStatusTooltip status={status} />}
        >
            <Chip
                sx={{
                    backgroundColor: status.bg,
                    color: status.text,
                    fontWeight: 500,
                    fontSize: "12px !important",
                }}
                icon={createElement(status.component(), {
                    fontSize: 14,
                    color: status.text,
                })}
                label={status.label}
            />
        </NoMaxWidthTooltip>
    );
}

export function HotelDepartureStatusCell({ value }: { value: PatientHotelDepartureStatuses }) {
    const status = hotelDepartureStatuses.find((status) => status.value === value);
    return (
        <div className="flex items-center py-1 h-full">
            {(status && <RenderHotelDepartureStatusCellTooltip status={status} />) || "-"}
        </div>
    );
}

export const HotelDepartureStatusColumn = ({
    t,
}: {
    t: TFunction;
}): GridColDef<IHotelPlanningDepartureResponseItem> => {
    return {
        field: "status",
        headerName: t("status"),
        minWidth: 140,
        valueGetter: (_val, row) => row.status,
        renderHeader: (params) => <TableHeader Component={TbUserScan} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <HotelDepartureStatusCell value={value} />,
    };
};
export default HotelDepartureStatusColumn;
